/** Default help topic ids for modal dialogs. */
export const dialogHelpTopics = {
  confirm: 'getting-started',
  input: 'getting-started',
  linkCopy: 'information-create',
  shareLink: 'information-create',
  folderGuestLink: 'files-create',
  sharedFolderCreate: 'files-create',
  sharedFolderExtend: 'files-create',
  filesMove: 'files-work',
  filesProperties: 'files-work',
  filePreview: 'files-work',
  fileTextEditor: 'files-work',
  vaultRecovery: 'recovery',
  recoveryExport: 'recovery',
  pcapStream: 'files-work',
  sedrCreate: 'sedr-create',
  sedrCreateRequirement: 'sedr-req-add',
  sedrExport: 'sedr-req-export',
  sedrImportHub: 'sedr-req-add',
  sedrImportWizard: 'sedr-req-add',
  sedrFilePicker: 'sedr-evidence-browse',
  sedrMove: 'sedr-evidence-organise',
  sedrProperties: 'sedr-evidence-organise',
  sedrApplyFolderSet: 'sedr-evidence-folder-set',
  sedrLibrary: 'sedr-library',
  sedrLibraryImport: 'sedr-library-requirements',
  sedrRoomCategory: 'sedr-settings',
  infoShareManage: 'information-list',
  infoShareReplies: 'information-list',
  sharedFolderInviteUser: 'files-create',
  sharedFolderInviteGuest: 'files-create',
  sharedFolderQuickShare: 'files-create',
  sharedFolderEditGuest: 'files-create',
  sedrInviteUser: 'sedr-members',
  sedrInviteGuest: 'sedr-invite-guest',
  sedrRequirementLink: 'sedr-req-detail',
  sedrReportAddRecipient: 'sedr-scheduled-report',
} as const;

export type DialogHelpTopicKey = keyof typeof dialogHelpTopics;

export function dialogHelpTopic(key: DialogHelpTopicKey): string {
  return dialogHelpTopics[key];
}
